import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { PaywallBannerUpgradeCta } from "@clockwise/web-commons/src/ui/paywall-banner-upgrade-cta";
import React from "react";
import { useMonetization } from "../../hooks/useMonetization";

const FlexibleMeetingsGuidance = () => {
  const { canUserAccessFlexMeetings, shouldUserSeeJoinExistingPlan } = useMonetization();

  return (
    <div className="cw-body-base">
      <div>
        When you mark meetings flexible, Clockwise will automatically move them to give you blocks
        of Focus Time and resolve conflicts.{" "}
        <a
          className="cw-text-green-darkest cw-underline hover:cw-text-green-darkester cw-cursor-pointer"
          href={articleUrls.autopilot}
          target="_blank"
          rel="noreferrer"
        >
          Which meetings should I mark flexible?
        </a>
      </div>
      {!canUserAccessFlexMeetings && (
        <PaywallBannerUpgradeCta
          showJoinExistingPlan={shouldUserSeeJoinExistingPlan}
          bannerType="FlexMeetingPage"
        />
      )}
    </div>
  );
};

export default FlexibleMeetingsGuidance;
